import intl from 'react-intl-universal'

export default {
  type: 'unknown',
  title: `Unknown Content Element`,
  icon: `question-circle-o `,
  template: `<p>${intl.get('blocks.image.unknown')}: {{feature.type}}</p>`,
}
